import { create } from 'zustand';
import * as ScreenOrientation from 'expo-screen-orientation';

/**
 * Shared device-orientation state — a single expo-screen-orientation listener
 * for the whole app. usePlatform is mounted by ~100 components; previously each
 * mount registered its own native listener. Components subscribe to this store
 * instead, so exactly one listener + one getOrientationAsync call exists.
 */
const usePlatformStore = create((set) => {
    try {
        ScreenOrientation.addOrientationChangeListener((event) => {
            const next = event.orientationInfo.orientation;
            set((state) => (state.orientation === next ? state : { orientation: next }));
        });

        ScreenOrientation.getOrientationAsync()
            .then((orientation) => set({ orientation, isResolved: true }))
            .catch((e) => console.warn('Failed to get initial orientation:', e));
    } catch (e) {
        // Environments without the native module (tests, etc.) — consumers
        // fall back to Dimensions-based orientation.
        console.warn('Failed to subscribe to orientation changes:', e);
    }

    return {
        orientation: ScreenOrientation.Orientation.PORTRAIT_UP,
        // Mirrors the old per-hook `firstRender` flag: false until
        // getOrientationAsync resolves; false forever if it rejects.
        isResolved: false,
    };
});

export default usePlatformStore;
